import { FieldError } from '@components/field-error';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { DatePickerProps } from 'antd';
import { Dayjs } from 'dayjs';

export type DProps<T extends FieldValues> = Omit<DatePickerProps, 'onChange' | 'value'> & {
  required?: boolean;
  label?: string;
  name: Path<T>;
  placeholder?: string;
  control: Control<T>;
  suffixLabel?: string;
  onChange?: (date: Dayjs | null) => void;
  value?: Dayjs | null;
};

export function AppDatePicker<T extends FieldValues>(props: DProps<T>) {
  const { required, label, name, placeholder, suffixLabel, control, onChange, value, ...restProps } = props;

  return (
    <div className="flex flex-col gap-0.5 md:gap-1.5 w-full">
      {label && (
        <p className="text-base leading-5 font-medium text-text-800">
          {label}
          <span className="text-text-400 text-xs font-normal">{suffixLabel && suffixLabel}</span>
          {required && <span className="text-red-500">*</span>}
        </p>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <div className="w-full flex flex-col gap-0.5 md:gap-1.5">
            <DatePicker
              size="large"
              status={error ? 'error' : ''}
              placeholder={placeholder}
              value={value || (field.value ? dayjs(field.value) : null)}
              onChange={(date) => {
                field.onChange(date ? date.format('YYYY-MM-DD') : '');
                onChange?.(date);
              }}
              {...restProps}
            />
            <FieldError message={error?.message} />
          </div>
        )}
      />
    </div>
  );
}
